<template>
	<div :style="style" v-touch:tap.stop="openInfoModal" v-on:click.stop="">
	</div>
</template>

<script>
export default {
	name: "Avatar",
	props: ['userId'],
	computed: {
		style() {

			const url = `${this.$settings.APIBaseURL}/asset/avatar/${this.userId}?username=${this.$UserSession.getValue("username")}&authToken=${this.$UserSession.getValue("authToken")}`;

			let style = `background-image: url(${url})`;

			if(this.isTeacher) {
				style = `${style};cursor: pointer;`;
			}

			return style;

		},
		isTeacher() {
			return this.$UserSession.hasPriv.call(this, "MARK_TREATMENTSESSIONS");
		}
	},
	mounted() {
		//console.log(this.$config.getValue('programmes'));
	},
	methods: {
		openInfoModal() {

			if(this.isTeacher) {

				this.$users.getUserById.call(this, this.userId).then(user => {

					let htmlContentArr = [
						`<div class="avatar--large float-left mr-4" style="${this.style}"></div>`,
						`<div class="block" style="padding-left: 145px">`
					];

					if(user.studentid) {
						htmlContentArr.push(`<p class="font-weight-bold mb-0">${this.$t('id-colon')} ${user.studentid}</p>`)
					}

					htmlContentArr.push(`<ul class="list-inline">`);

					if(user.programme) {
						htmlContentArr.push(`<li class="list-inline-item">${this.$t('programme-colon')} ${this.$config.getProgrammeNameById(user.programme)}</li>`)
					}
					if(user.year) {
						htmlContentArr.push(`<li class="list-inline-item">${this.$t('year-colon')} ${this.$config.getUserYearStr(user)}</li>`)
					}
					if(user.group) {
						htmlContentArr.push(`<li class="list-inline-item">${this.$t('group-colon')} ${this.$config.getGroupNameById(user.group)}</li>`)
					}
					if(user.firm) {
						htmlContentArr.push(`<li class="list-inline-item">${this.$t('firm-colon')} ${this.$config.getFirmNameById(user.firm)}</li>`)
					}
					htmlContentArr.push(`</ul>`);

					if(user.flags.length) {
						htmlContentArr.push(`<ul class="list-inline">`)
						for(let flag of user.flags) {
							htmlContentArr.push(`<li class="list-inline-item mb-2"><span class="userflag ${flag.value}">${flag.name}</span></li>`)
						}
						htmlContentArr.push(`</ul>`);
					}
					htmlContentArr.push(`</div>`);


					this.$store.commit("openDialog" , {
						cancelBtn: false,
						htmlContent: htmlContentArr.join(''),
						title: user.displayName
					});
				});

			}

			return false;
		}
	}
};
</script>
